import { createFileRoute } from "@tanstack/react-router";

import { OccasionLanding } from "../components/landing/occasion-landing";
import { seo } from "../lib/head";
import { OCCASION_PAGES } from "../lib/occasion-pages";

export const Route = createFileRoute("/liste-de-mariage")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: OCCASION_PAGES.wedding.seoTitle,
      description: OCCASION_PAGES.wedding.seoDescription,
      image: OCCASION_PAGES.wedding.ogImage,
    }),
  component: () => <OccasionLanding occasion="wedding" />,
});
